import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';
import { ConfirmationModalModule } from 'src/app/ui/components/confirmation-modal/confirmation-modal.module';
import { SearchBarModule } from 'src/app/ui/components/search-bar/search-bar.module';

import { PatientCellModule } from '../patient-cell/patient-cell.module';
import { PatientGroupPatientEditComponent } from './patient-group-patient-edit.component';

@NgModule({
  declarations: [PatientGroupPatientEditComponent],
  imports: [
    CommonModule,
    ConfirmationModalModule,
    NgxBootstrapIconsModule,
    NgxInnerLoadingModule,
    PatientCellModule,
    SearchBarModule,
  ],
  exports: [PatientGroupPatientEditComponent],
})
export class PatientGroupPatientEditModule {}
